import {
  setEndUserAccountState,
  setEndUserDashboardStateResolved,
  setEndUserDashboardSteps,
  setEndUserExpenseConfirmationConsentAccepted,
  setEndUserFirstName,
  setEndUserHasExpenses,
  setEndUserOrgName,
  setEndUserProfileState,
  setEndUserUnitName,
} from 'store/slices/authSlice';

import type { EndUserDashboardState } from 'services/api/endUserDashboardApi.data';
import { loadEndUserDashboardState } from 'services/endUser/loadEndUserDashboardState';

import type { AppDispatch } from 'store/store';

export const applyEndUserProfileToStore = (
  dashboard: EndUserDashboardState,
  dispatch: AppDispatch
): void => {
  dispatch(setEndUserFirstName(dashboard.firstName));
  dispatch(setEndUserOrgName(dashboard.orgName));
  dispatch(setEndUserUnitName(dashboard.unitName));
  dispatch(setEndUserAccountState(dashboard.accountState ?? null));
  dispatch(setEndUserProfileState(dashboard.profileState ?? null));
  dispatch(
    setEndUserExpenseConfirmationConsentAccepted(dashboard.expenseConfirmationConsentAccepted)
  );
  dispatch(setEndUserDashboardSteps(dashboard.steps));
  dispatch(setEndUserHasExpenses(dashboard.hasExpenses === true));
  dispatch(setEndUserDashboardStateResolved(true));
};

export const hydrateEndUserProfile = async (
  euId: string,
  idToken: string,
  dispatch: AppDispatch
): Promise<EndUserDashboardState | null> => {
  try {
    const dashboard = await loadEndUserDashboardState(euId, idToken);
    applyEndUserProfileToStore(dashboard, dispatch);
    return dashboard;
  } catch {
    return null;
  }
};
